import { render, staticRenderFns } from "./ModalVisualizacao.vue?vue&type=template&id=036b4294&scoped=true&lang=pug"
import script from "./ModalVisualizacao.vue?vue&type=script&lang=js"
export * from "./ModalVisualizacao.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizacao.vue?vue&type=style&index=0&id=036b4294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b4294",
  null
  
)

export default component.exports